/**
 * Narrows an unknown thrown value (an `Error`, or the typed error object thrown by
 * `apiRequest`) to a displayable message, falling back when none is usable.
 */
export function errorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string" && message.trim()) return message;
  }
  return fallback;
}
